import { render, staticRenderFns } from "./my-clubs-table.vue?vue&type=template&id=7524f4ac"
import script from "./my-clubs-table.vue?vue&type=script&lang=js"
export * from "./my-clubs-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7524f4ac')) {
      api.createRecord('7524f4ac', component.options)
    } else {
      api.reload('7524f4ac', component.options)
    }
    module.hot.accept("./my-clubs-table.vue?vue&type=template&id=7524f4ac", function () {
      api.rerender('7524f4ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/my-clubs/my-clubs-table/my-clubs-table.vue"
export default component.exports